import React from 'react';
import cn from 'classnames';
import createPaginationArray from '@bosch/react-frok/lib/atoms/pageIndicator/functions/createPaginationArray';

export interface PageIndicatorProps {
    readonly pages: number;
    readonly selected: number;
    onPageSelect: (page: number) => void;
}

/**
 * @name PageIndicator
 * @description
 * A page indicator with the possibility to navigate between pages
 */
export const PageIndicator: React.VFC<PageIndicatorProps> = (props) => {
    const leftArrowEnabled = !(props.selected <= 1);
    const leftArrowClasses = cn('a-page-indicator__caret -left', {
        '-end': !leftArrowEnabled
    });

    const rightArrowEnabled = !(props.selected >= props.pages);
    const rightArrowClasses = cn('a-page-indicator__caret -right', {
        '-end': !rightArrowEnabled
    });

    let pageArray = createPaginationArray(props.selected, props.pages);

    return (
        <div
            className='a-page-indicator a-page-indicator--numbered'
            data-start-index={props.selected}
            data-max-length={props.pages}
            aria-label='Page indicator'
        >
            <div
                className={leftArrowClasses}
                onClick={() => {
                    if (leftArrowEnabled) props.onPageSelect(props.selected - 1);
                }}
            />
            <div className='a-page-indicator__container'>
                {pageArray.map((page, index) => {
                    const indicatorClass = cn('a-page-indicator__indicator', {'-selected': props.selected === page});
                    return (
                        <div
                            className={indicatorClass}
                            key={index}
                            data-index={typeof page === 'number' ? page : null}
                            onClick={(event) => {
                                props.onPageSelect(Number(event.currentTarget.getAttribute('data-index')));
                            }}
                        >
                            <span>{page}</span>
                        </div>
                    );
                })}
            </div>
            <div
                className={rightArrowClasses}
                onClick={() => {
                    if (rightArrowEnabled) props.onPageSelect(props.selected + 1);
                }}
            />
        </div>
    );
};
